export default "__VITE_ASSET__54k_DlK8__"